import Vue from 'vue'
import Vuetify from 'vuetify/lib';
import Vuelidate from 'vuelidate'
import VueAxios from 'vue-axios'

import axios from 'axios'
import colors from 'vuetify/lib/util/colors'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import App from './components/App.vue'

import i18n from './i18n'
import store from './store'
import router from './router'

Vue.use(Vuelidate)
Vue.use(Vuetify);
Vue.use(VueAxios, axios)
let ip = document.URL.split('/');

const apiUrl =  process.env.VUE_APP_API_URL
axios.defaults.baseURL = (apiUrl && apiUrl.length > 0)
    ? location.protocol + "//" + process.env.VUE_APP_API_URL + '/sharesuite/'
    :  location.protocol + '//' + ip[2] + '/sharesuite/';

axios.defaults.withCredentials = true

Vue.config.productionTip = false
new Vue({
    router,
    store,
    i18n,
    vuetify: new Vuetify({
        theme: {
            themes: {
                light: {
                    primary: '#5fa2dd',
                    secondary: colors.grey.darken1,
                    accent: '#5fa2dd',
                    success: '#89c277',
                    error: '#ee7583',
                },
            },
        },
        icons: {
            iconfont: 'md',
        },
    }),
    render: h => h(App)
}).$mount('#app')
